import { render } from "./Puncture_force.vue?vue&type=template&id=38c52477&scoped=true"
import script from "./Puncture_force.vue?vue&type=script&lang=js"
export * from "./Puncture_force.vue?vue&type=script&lang=js"

import "./Puncture_force.vue?vue&type=style&index=0&id=38c52477&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c52477"]])

export default __exports__